import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { IconButton, Link } from '@mui/material'
import PageLoading from '../../../components/PageLoading/PageLoading'
import InformationTable from '../../../components/Table/InformationTable'
import MesRecienteSelector from '../../../components/form/MesRecienteSelector/MesRecienteSelector'
import TableHeader from '../../../components/TableHeader/TableHeader'
import {
  monthToString,
  dateToString,
  compareRawDates
} from '../../../utils/date'
import { getPackSeguimiento } from '../../../utils/api/packs'
import { textFilter } from '../../../utils/table'
import { useNotification } from '../../../context/NotificationManager/NotificationManager'
import ModalDetalleAsistencias from '../../../modals/ModalDetalleAsistencias/ModalDetalleAsistencias'
import css from './Packs.module.css'

const getHorasText = pack => {
  if (!pack || !pack.asistencias) return '--'
  const horasConsumidas = pack.asistencias.length || 0
  const horasContratadas = pack.horas || 0
  return `${horasConsumidas}/${horasContratadas}`
}

const getUltimasHorasProgramadas = pack => {
  const ultimas = [...(pack.asistencias || [])]
    .sort(
      (a, b) =>
        compareRawDates(a.fecha, b.fecha) ||
        (a.hora || '').localeCompare(b.hora || '')
    )
    .slice(-2)
    .map(a => `${dateToString(a.fecha)} ${a.hora || ''}`)
  return ['--', '--', ...ultimas].slice(-2)
}

const Packs = () => {
  const notification = useNotification()
  const [search, setSearch] = useState('')
  const [mes, setMes] = useState(monthToString(new Date()))
  const [openModalDetalleAsistencias, setOpenModalDetalleAsistencias] =
    useState(false)
  const [packSeleccionado, setPackSeleccionado] = useState(null)

  const { isLoading, data: seguimientoPacks = [] } = useQuery({
    queryKey: ['contabilidad', 'pack-horas-alumno', 'seguimiento', mes],
    queryFn: () =>
      getPackSeguimiento(mes).catch(err => {
        notification.error({
          title: 'Error al recuperar los packs',
          content: err
        })
        return []
      })
  })

  const handleModalDetalleAsistencia = pack => {
    setPackSeleccionado(pack)
    setOpenModalDetalleAsistencias(true)
  }

  const filterSearch = pack => {
    return textFilter({
      object: pack,
      fields: ['alumno', 'pack'],
      search: search
    })
  }

  return (
    <PageLoading isLoading={isLoading}>
      <div className={css.main}>
        <TableHeader
          actions={
            <div className={css.actions}>
              <MesRecienteSelector
                name='mes'
                label='Mes'
                value={mes}
                backwardOptions={3}
                forwardOptions={1}
                onChange={e => setMes(e.target.value)}
              />
            </div>
          }
          title='Packs'
          search={search}
          onSearchChange={e => setSearch(e.target.value)}
        />
        <InformationTable
          details={[
            { title: 'Alumno', key: 'alumno', sortDisabled: true },
            { title: 'Pack', key: 'pack', sortDisabled: true },
            {
              title: 'Horas',
              key: 'horas',
              align: 'center',
              sortDisabled: true
            },
            { title: 'Penúltima clase', key: 'penultima', sortDisabled: true },
            { title: 'Última clase', key: 'ultimas', sortDisabled: true },
            { title: 'Detalles', key: 'detalles', sortDisabled: true }
          ]}
          data={seguimientoPacks.filter(filterSearch).map(pack => ({
            alumno: (
              <Link
                className={css.link}
                href={`/alumnos/${pack.alumnoId}/ficha`}
              >
                {pack.alumno || '--'}
              </Link>
            ),
            pack: pack.pack || '--',
            horas: getHorasText(pack),
            penultima: getUltimasHorasProgramadas(pack)[0],
            ultimas: getUltimasHorasProgramadas(pack)[1],
            detalles: (
              <IconButton
                color='primary'
                size='small'
                onClick={() => handleModalDetalleAsistencia(pack)}
              >
                <i className='material-icons'>description</i>
              </IconButton>
            )
          }))}
        />
      </div>
      <ModalDetalleAsistencias
        open={openModalDetalleAsistencias}
        onClose={() => setOpenModalDetalleAsistencias(false)}
        pack={packSeleccionado}
      />
    </PageLoading>
  )
}

export default Packs
